import React from 'react';
import classNames from 'classnames';
import { Chevron } from '../Icons';

const getClassNames = (size: string | null, direction: string) =>
  classNames({
    'sl-scroll-control': true,
    'sl-scroll-control--tall': size === 'tall',
    'sl-scroll-control--left': direction === 'left',
    'sl-scroll-control--right': direction === 'right',
  });

type Props = {
  direction: string;
  clickHandler: (event: React.MouseEvent<HTMLDivElement>) => void;
  size: string;
};

const ScrollControl: React.FC<Props> = ({ direction, size = null, clickHandler = undefined }) => (
  <div className={getClassNames(size, direction)} onClick={clickHandler}>
    <Chevron direction={direction} />
  </div>
);

export default ScrollControl;
